import { render, staticRenderFns } from "./LiftcarVer.vue?vue&type=template&id=708008a7&scoped=true"
import script from "./LiftcarVer.vue?vue&type=script&lang=js"
export * from "./LiftcarVer.vue?vue&type=script&lang=js"
import style0 from "./LiftcarVer.vue?vue&type=style&index=0&id=708008a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708008a7",
  null
  
)

export default component.exports